import { IContentHubClient } from "../../clients/content-hub-client";
import Guard from "../../guard";
import { IEntity } from "../base/entity";
import { EntityIterator, IEntityIterator } from "./entity-iterator";
import { IEntityLoadConfiguration } from "./entity-load-configuration";
import { Query } from "./query";
import { IQueryResult } from "./query-result";

export interface IEntityQueryResult extends IQueryResult<IEntity> {
    createIterator(): IEntityIterator;
}

export abstract class QueryResultBase<T> implements IQueryResult<T> {
    abstract items: Array<T>;

    totalNumberOfResults: number;

    offset: number;

    constructor(totalItems: number, offset: number) {
        Guard.notNegative(totalItems);
        Guard.notNegative(offset);

        this.totalNumberOfResults = totalItems;
        this.offset = offset;
    }
}

export class EntityQueryResult extends QueryResultBase<IEntity> implements IEntityQueryResult {
    private readonly _client: IContentHubClient;
    private readonly _query: Query;
    private readonly _loadConfiguration: IEntityLoadConfiguration;

    items: Array<IEntity>;

    constructor(
        client: IContentHubClient,
        query: Query,
        loadConfiguration: IEntityLoadConfiguration,
        entities: Array<IEntity>,
        totalItems: number,
        offset: number
    ) {
        super(totalItems, offset);

        Guard.notNullOrUndefined(client);
        Guard.notNullOrUndefined(query);
        Guard.notNullOrUndefined(entities);

        this._client = client;
        this._query = query;
        this._loadConfiguration = loadConfiguration;
        this.items = [...entities];
    }

    createIterator(): IEntityIterator {
        return new EntityIterator(this._client, this._query, this._loadConfiguration, this);
    }
}
